<template>
    <div>
        <div v-if="loading" class="col-md-12 text-center" style="margin-top:25%">
            <PulseLoader :loading="loading" :color="color" :size="size"></PulseLoader>
        </div>
        <div v-if="!loading" class="row">
            <div class="col-md-12 col-sm-12 ">
                <div class="x_panel">
                    <h2 class="float-left"> {{DeferReschedule ? 'Defer Job List' : JobDoneStatus ? 'Job Done' : P2W ? 'Permit To Work' : IRR ? 'Risk Assessment' : 'Upcoming Job List'}}</h2>
                    <ul class="nav navbar-right panel_toolbox">
                        <button v-if="!listMode" @click="changeListMode" class="btn btn-danger btn-sm float-right">Back <i class="fa fa-arrow-circle-o-right"></i></button>
                        <router-link v-if="listMode && isPermissionExist(PERMISSIONS.OVERDUE_JOB_REPORT)" to="/over-due-job" class="btn btn-info btn-sm float-right">Overdue Job</router-link>
                        <button @click="handlePrint" :disabled="isPrinting" v-if="listMode && isPermissionExist(PERMISSIONS.MAINTENANCE_PRINT)" class="btn btn-warning btn-sm float-right">
                            <i class="fa fa-print" v-if="!isPrinting"></i>
                            <i class="fa fa-spinner fa-spin" v-if="isPrinting"></i>
                            {{ isPrinting ? 'Printing...' : 'Print' }}
                        </button>
                        <vue-excel-xlsx v-if="isPermissionExist(PERMISSIONS.MAINTENANCE_PRINT)" class="btn btn-primary btn-sm float-right" :data="excelData" :columns="excelHeader" :file-name="'Maintenance'" :file-type="'xlsx'" :sheet-name="'sheetname'">
                            <i class="fa fa-file-excel-o"></i> Excel
                        </vue-excel-xlsx>
                        <button v-if="listMode" @click="goBack" class="btn btn-danger btn-sm float-right">Back <i class="fa fa-arrow-circle-o-right"></i></button>
                    </ul>
                </div>
                <div class="">
                    <div class="x_content ">
                        <div class="row" v-if="listMode">
                            <div class="col-md-12">
                                <div class="card">

                                    <div class="x_panel">
                                        <div class="x_content">
                                            <div class="row">

                                                <div class="col-md-2">
                                                    <div class="form-group">
                                                        <label>Date From</label>
                                                        <DatePicker type="date" v-model="formData.date_from" valueType="format"></DatePicker>
                                                    </div>
                                                </div>
                                                <div class="col-md-2">
                                                    <div class="form-group">
                                                        <label>Date To</label>
                                                        <DatePicker type="date" v-model="formData.date_to" valueType="format"></DatePicker>
                                                    </div>
                                                </div>
                                                <div class="col-md-2">
                                                    <div class="form-group">
                                                        <label>Counter Type</label>
                                                        <select class="form-control" v-model="formData.counter_type">
                                                            <option value>Select Job Interval</option>
                                                            <option value="Yearly">Yearly</option>
                                                            <option value="Two-Yearly">2 yearly</option>
                                                            <option value="Thirty-Monthly">2.5 yearly</option>
                                                            <option value="Three-Yearly">3 yearly</option>
                                                            <option value="Four-Yearly">4 yearly</option>
                                                            <option value="Five-Yearly">5 yearly</option>
                                                            <option value="Ten-Yearly">10 yearly</option>
                                                            <option value="Fifteen-Yearly">15 yearly</option>
                                                            <option value="Monthly">Monthly</option>
                                                            <option value="Three-Monthly">3 Monthly</option>
                                                            <option value="Six-Monthly">6 Monthly</option>
                                                            <option value="Weekly">Weekly</option>
                                                            <option value="Running Hours">Running Hour</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div class="col-md-2">
                                                    <div class="form-group">
                                                        <label>Critical Jobs</label>
                                                        <select class="form-control" v-model="formData.critical_jobs">
                                                            <option value>Select Critical Jobs</option>
                                                            <option value="yes">Yes</option>
                                                            <option value="no">No</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div class="col-md-2">
                                                    <div class="form-group">
                                                        <label>Critical Components</label>
                                                        <select class="form-control" v-model="formData.job_type">
                                                            <option value>Select Critical Components</option>
                                                            <option value="Yes">Yes</option>
                                                            <option value="No">No</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div class="col-md-2">
                                                    <div class="form-group">
                                                        <label>Job Status</label>
                                                        <select class="form-control" v-model="formData.status">
                                                            <option value>Select Job Status</option>
                                                            <option value="Pending">Pending</option>
                                                            <option value="In_Progress">In Progress</option>
                                                            <option value="Done">Done</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div class="col-md-2" v-if="isPermissionExist(PERMISSIONS.MAINTENANCE_ASSIGNED_RANKED)">
                                                    <div class="form-group">
                                                        <label>Assign Rank</label>
                                                        <select v-model="formData.rank_fixed" class="form-control">
                                                            <option value="">Select Rank</option>
                                                            <option v-for="role in roles" :key="role.id" :value="role.id">{{role.name}}</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div class="col-md-2 col-6 ">
                                                    <div class="form-group">
                                                        <label for="searchInput">Search </label>
                                                        <input type="text" placeholder="Enter job name or code" v-model="formData.search_input" name="searchInput" class="form-control" id="searchInput">
                                                    </div>
                                                </div>
                                                <div class="col-md-1">
                                                    <button style="margin-top: 26px" @click="getAllJobList()" class="btn btn-info btn-sm">Search</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="card-body">
                                        <div class="card-box table-responsive">
                                            <table class="table table-sm table-striped table-bordered vertical-align-middle text-center" id="maintenanceTable" style="width: 100%">
                                                <thead>
                                                <tr>
                                                    <th :set="serial = 1">#</th>
                                                    <th>Department</th>
                                                    <th>Component Name</th>
                                                    <th>Job Name (Job Code)</th>
                                                    <th>Job Type</th>
                                                    <th>Counter Type</th>
                                                    <th>Prev Maintenance Date</th>
                                                    <th>Next Maintenance Due Date</th>
                                                    <th v-if="isPermissionExist(PERMISSIONS.MAINTENANCE_ASSIGNED_RANKED)">Assigned</th>
                                                    <th>Status</th>
                                                    <th>Action</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr v-for="(job, index) in jobList" :key="index">
                                                    <td>{{ serial++ }}</td>
                                                    <td>{{job.department}}</td>
                                                    <td>{{job.components}}</td>
                                                    <td>{{job.name+"("+job.code+")"}}</td>
                                                    <td>{{job.job_type_name}}</td>
                                                    <td>{{job.counter_type}}</td>
                                                    <td>{{job.start_date | moment('DD-MM-YYYY') }}</td>
                                                    <td>{{job.end_date | moment('DD-MM-YYYY')}} <span v-if="job.defer" class="badge badge-danger">Defer  </span></td>
                                                    <td width="12%" v-if="isPermissionExist(PERMISSIONS.MAINTENANCE_ASSIGNED_RANKED)">
                                                        <div class="form-group">
                                                            <select class="form-control" @change="assignRanked($event, job.job_id)">
                                                                <option v-for="role in roles" v-bind:selected="parseInt(job.rank_fixed) === parseInt(role.id)" :key="role.id" :value="role.id">{{role.name}}</option>
                                                            </select>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <span class="badge badge-warning" v-if="(job.status === 'Pending') && (moment(job.end_date) > moment())">Upcoming</span>
                                                        <span class="badge badge-danger" v-else-if="job.status === 'Pending'">Overdue</span>
                                                        <span class="badge badge-info" v-else-if="job.status === 'In_Progress'">In Progress</span>
                                                        <span class="badge badge-success" v-else-if="job.status === 'Done'">Done</span>
                                                    </td>
                                                    <td>
                                                        <!--RISK ASSESSMENT BUTTON -->
                                                        <button title="Job Instruction" class="btn btn-secondary btn-sm" @click="readJobRemark(job)"><i class="fa fa-book"></i></button>
                                                        <div v-if="isPermissionExist(PERMISSIONS.MAINTENANCE_JOB_DONE)">
                                                            <button title="Job Done" type="button" v-if="job.status === 'Pending'" class="btn btn-info btn-sm" @click="jobDoneFunction(job)"><i class="fa fa-thumbs-up"></i></button>
                                                            <button title="Job Done" type="button" v-else-if="job.status === 'In_Progress'" class="btn btn-primary btn-sm" @click="jobDoneFunction(job)"><i class="fa fa-thumbs-up"></i></button>
                                                            <button title="Job Done" type="button" v-else class="btn btn-success btn-sm" @click="jobDoneFunction(job)"><i class="fa fa-thumbs-up"></i></button>
                                                        </div>
                                                        <button v-if="isPermissionExist(PERMISSIONS.MAINTENANCE_DEFER_JOB)" title="Deffer Job " class="btn btn-sm btn-info" type="button" @click="viewDeferSchedule(job,index)"><i class="fa fa-compass" aria-hidden="true"></i></button>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                        <Pagination v-if="this.pagination" :pagination="jobList" :getData="getAllJobList"/>

                                        <div id="printArea" style="display: none">
                                            <div style="text-align: center">
                                                <h2 style="line-height: 10px;">{{ appName }}</h2>
                                                <h4 style="line-height: 10px;">Vessel Name: {{this.vessel_name}}</h4>
                                                <h3 style="line-height: 10px;">Upcoming Job List</h3>
                                                <p style="line-height: 10px;">Printing Date: {{new Date().toISOString().substring(0, 10)}}</p>
                                            </div>
                                            <table class="table  table-bordered text-center print-table" style="width: 100%; ">
                                                <thead>
                                                <tr>
                                                    <th :set="sl = 0">#</th>
                                                    <th> Department</th>
                                                    <th> Component Name</th>
                                                    <th> Job Name(Job Code)</th>
                                                    <th> Job Type</th>
                                                    <th>Counter Type</th>
                                                    <th>Prev Maintenance Date</th>
                                                    <th>Next Maintenance Due Date</th>
                                                    <th v-if="isPermissionExist(PERMISSIONS.MAINTENANCE_ASSIGNED_RANKED)">Assign To</th>
                                                    <th>Status</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr v-for="(job, index) in printItems" :key="index">
                                                    <td>{{ serial++ }}</td>
                                                    <td>{{job.department}}</td>
                                                    <td>{{job.components}}</td>
                                                    <td>{{job.name+"("+job.code+")"}}</td>
                                                    <td>{{job.job_type_name}}</td>
                                                    <td>{{job.counter_type}}</td>
                                                    <td>{{job.start_date | moment('DD-MM-YYYY') }}</td>
                                                    <td>{{job.end_date | moment('DD-MM-YYYY')}} <span v-if="job.defer" class="badge badge-danger">Defer  </span></td>
                                                    <td v-if="isPermissionExist(PERMISSIONS.MAINTENANCE_ASSIGNED_RANKED)">{{getRankName(job.rank_fixed)}}</td>
                                                    <td>
                                                        <span class="badge badge-warning" v-if="(job.status === 'Pending') && (moment(job.end_date) > moment())">Upcoming</span>
                                                        <span class="badge badge-danger" v-else-if="job.status === 'Pending'">Overdue</span>
                                                        <span class="badge badge-info" v-else-if="job.status === 'In_Progress'">In Progress</span>
                                                        <span class="badge badge-success" v-else-if="job.status === 'Done'">Done</span>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <RiskAssessment v-if="IRR" :jobInfo="selectedJob" :Schedule="scheduleId" :mode="permitWorkMode" @enableListMode="changeListMode"/>
                        <PermitToWork v-if="P2W" :jobInfo="selectedJob" :chiefMode='chiefPermisionMode' :mode="permitWorkMode" :Schedule="scheduleId" @enableListMode="changeListMode"/>
                        <JobDone v-if="JobDoneStatus" :jobInfo="selectedJob" :mode="permitWorkMode" :componentName="componentName" :jobName="job_name" :Schedule="scheduleId" @enableListMode="changeListMode"/>
                        <DeferReschedule v-if="DeferReschedule" :jobInfo="selectedJob" :Schedule="scheduleId" @enableListMode="changeListMode"/>

                    </div>
                </div>
            </div>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="showModal" tabindex="-1" role="dialog" aria-labelledby="showModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="showModalLabel"> Job Instruction</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <a href="javascript:;" @click="print('jobRemarks')" style="background: #08c;color: white;" class="btn  btn-sm "><i
                                    class="fa fa-print"></i> Print</a>
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div class="modal-body">
                        <div id="jobRemarks">
                            <span v-html="jobRemarks"></span>
                        </div>

                        <div class="row">
                            <div class="col-md-6"></div>
                            <div class="col-md-6"></div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>

    import moment from 'moment';
    import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
    import DatePicker from 'vue2-datepicker'
    import 'vue2-datepicker/index.css'
    import Tree from 'vuejs-tree'
    import {VueEditor} from 'vue2-editor'
    import exportMixin from "@/mixin/exportMixin";
    import RiskAssessment from './RiskAssessment'
    import PermitToWork from './PermitToWork'
    import JobDone from './JobDone'
    import DeferReschedule from './DeferReschedule'
    import auth from '@/auth'
    import permissionsMixin from "@/mixin/permissionsMixin";
    import printMixin from "@/mixin/printMixin";
    import goBackButtonMixin from "@/mixin/goBackButtonMixin";
    import {apiPrintData} from "@/utils/print";

    export default {
        mixins: [permissionsMixin, printMixin, goBackButtonMixin, exportMixin],
        name: 'Maintenance',
        components: {
            VueEditor,
            RiskAssessment,
            PermitToWork,
            JobDone,
            DeferReschedule,
            Tree,
            DatePicker,
            PulseLoader
        },
        data() {
            return {
                loading: false,
                color: '#1ABB9C',
                size: '10px',
                jobId: this.$route.params.jobId,
                selectedComponent: '',
                permissions: auth.getPermissionData(),
                selectedJob: Object,
                treeDisplayData: [],
                roles: [],
                scheduleId: '',
                componentName: '',
                job_name: '',
                jobType: '',
                query: '',
                content: '',
                queryFiled: 'name',
                components: [],
                jobList: [],
                printItems: [],
                excelHeader: [],
                excelData: [],
                jobRemarks: '',
                listMode: true,
                pagination: false,
                isPrinting: false,
                IRR: false,
                P2W: false,
                appName: process.env.VUE_APP_NAME,
                JobDoneStatus: false,
                DeferReschedule: false,
                editMode: false,
                permitWorkMode: false,
                tableEnableMode: false,
                chiefPermisionMode: false,
                vessel_id: auth.getVesselId(),
                user_type: auth.getUserType(),
                vessel_name: auth.getVesselName(),
                offset: 20,
                formData: new Form({
                    vessel_id: auth.getVesselId(),
                    date_from: moment().format('YYYY-MM-DD'),
                    date_to: moment().add(1, 'months').format('YYYY-MM-DD'),
                    rank_fixed: '',
                    counter_type: '',
                    search_input: '',
                    job_type: '',
                    critical_jobs: '',
                    status: '',
                }),
                form: new Form({
                    id: '',
                    name: '',
                    email: '',
                    status: 'Activate'
                }),
                filter: new Form({
                    dateRange: '',
                    jobType: '',
                    jobId: '',
                    vessel_id: auth.getVesselId(),
                }),
            }
        },
        mounted() {
            this.allRole();
            //quick job find from dashboard
            if (this.jobId) {
                this.getJobAllScheduleList();
            }
            this.getAllJobList();
            this.dataTableEnable();
        },
        computed: {
            moment() {
                return moment
            },
        },
        methods: {
            allRole() {
                this.$http.get("/api/filter/get-active-role").then(response => {
                    this.roles = response.data.success;
                    // setTimeout(() => $('#datatables').DataTable(), 1000);
                }).catch(e => {
                    console.log(e);
                });
            },
            isPending(schedule) {
                return schedule && schedule.status === 'Pending' && this.isEndDatePending(schedule.end_date);
            },
            isOverdue(endDate) {
                return endDate && this.getCurrentDate() > new Date(endDate);
            },
            isEndDatePending(endDate) {
                return endDate && this.getCurrentDate() <= new Date(endDate);
            },
            getCurrentDate() {
                // Get the current date without time (assuming your dates have no time information)
                var currentDate = new Date();
                currentDate.setHours(0, 0, 0, 0);
                return currentDate;
            },
            getStatusLabel(schedule) {
                if (this.isPending(schedule)) {
                    return 'Pending';
                } else if (this.isOverdue(schedule.end_date)) {
                    return 'Overdue';
                }
                return ''; // Add handling for other cases if needed
            },
            prepareExportData(jobList) {
                let rows = [];
                if (!jobList || !jobList) return rows;

                jobList.forEach(job => {
                    rows.push({
                        'Department': `${job.department || ''})`,
                        'Component Name': job.components || 'N/A',
                        'Job Name': `${job?.name || ''} (${job?.code || ''})`,
                        'Job Type': job?.job_type_name || '',
                        'Counter Type': job?.counter_type || '',
                        'Prev Maintenance Date': job.start_date
                            ? this.$moment(job.start_date).format('DD-MM-YYYY')
                            : '',
                        'Next Maintenance Due Date': job.end_date
                            ? this.$moment(job.end_date).format('DD-MM-YYYY')
                            : '',
                        'Assigned Rank': this.getRankName(job.rank_fixed),
                        'Status': job.status
                    });
                });

                return rows;
            },
            getRankName(rankId) {
                if (!rankId || !this.roles?.length) return '';
                let role = this.roles.find(r => r.id == rankId);
                return role ? role.name : '';
            },
            excelExport(jobList) {
                let data = this.prepareExportData(jobList);
                if (!data || data.length === 0) {
                    this.excelHeader = [];
                    this.excelData = [];
                    return;
                }

                // Build headers dynamically from the first row
                let excelHeader = Object.keys(data[0]).map(key => ({
                    label: key,
                    field: key
                }));

                this.excelHeader = excelHeader;
                this.excelData = data;
            },
            onPerPageChange() {
                this.getAllJobList(1);
            },
            getAllJobList(page = 1) {
                this.loading = true;
                this.jobList = [];
                let params = {
                    vessel_id: this.vessel_id,
                    page: page,
                };
                this.formData.post('/api/filter/all-job', {params}).then(response => {
                    this.jobList = response?.data;
                    this.excelExport(this.jobList);
                    this.loading = false;
                }).catch(e => {
                    this.loading = false;
                    let response = e.response;
                    if (response?.status === 403) {
                        this.$snotify.warning(response?.data?.error)
                    }
                })
            },
            async handlePrint() {
                this.isPrinting = true;

                try {
                    const params = {
                        vessel_id: this.form.vessel_id,
                        is_all: 1,
                    };

                    const res = await this.formData.post('/api/filter/all-job', {params});
                    this.printItems = res?.data ?? [];

                    this.$nextTick(() => {
                        apiPrintData('printArea', 'Upcoming Job List');
                        this.isPrinting = false;
                    });

                } catch (error) {
                    console.error(error);
                    this.isPrinting = false;
                    printWindow.close();
                }
            },
            getJobAllScheduleList() {
                this.$http.get('/api/filter/job/' + this.jobId + '/' + this.vessel_id).then(response => {
                    this.jobList = [];
                    $('.dataTables_empty').closest('tr').remove();
                    this.jobList = response.data.success
                    // setTimeout(() => $('#datatables').DataTable(), 1000)
                }).catch(e => {
                    console.log(e)
                })
            },
            searchSchedule() {
                this.filter.busy = true;
                this.filter.post('/api/filter/search-jobschedule').then(response => {
                    if (this.filter.successful) {
                        this.jobList = [];
                        this.jobList = response.data.success;
                        $('.dataTables_empty').closest('tr').remove()
                        // setTimeout(() => $('#datatables').DataTable(), 1000)
                    } else {
                        this.jobList = []
                        // setTimeout(() => $('#datatables').DataTable(), 1000)
                    }
                }).catch(e => {
                    var error = this.filter.errors.errors.error;
                    this.$snotify.warning('Sorry Item Is Not Found')
                })
            },
            createRA(job, i) {
                this.listMode = false;
                this.IRR = true;
                this.selectedJob = job;
                let RiskAssessmentLenght = job.job_schedules[i].risk_assessment.length;
                if (RiskAssessmentLenght > 0) {
                    this.permitWorkMode = true
                } else {
                    this.permitWorkMode = false
                }
                this.scheduleId = i
            },
            viewDeferSchedule(job, i) {
                this.listMode = false;
                this.DeferReschedule = true;
                this.selectedJob = job;
                this.scheduleId = i
            },
            createRaAleart() {
                this.$snotify.warning('Risk Assessment Is not Submitted')
            },

            createP2WAleart() {
                this.$snotify.warning('Work Permission Not Send')
            },
            createCL() {
                this.editMode = false;
                this.form.reset();
                this.form.clear();
                $('#roleModalCL').modal('show')
            },
            createP2W(job, i) {
                if (job.job_schedules[i].permit_to_work != null) {
                    this.permitWorkMode = true
                } else {
                    this.permitWorkMode = false
                }
                this.listMode = false;
                this.IRR = false;
                this.P2W = true;
                this.selectedJob = job;
                this.scheduleId = i
            },
            createP2WChiefMode(job, i) {
                if (job.job_schedules[i].permit_to_work != null) {
                    this.permitWorkMode = true
                } else {
                    this.permitWorkMode = false
                }
                this.chiefPermisionMode = true;
                this.listMode = false;
                this.IRR = false;
                this.P2W = true;
                this.selectedJob = job;
                this.scheduleId = i
            },
            readJobRemark(job) {
                this.jobRemarks = job.job_remarks;
                $('#showModal').modal('show')
            },
            jobDoneFunction(job) {
                // if(job.job_schedules[i].permit_to_work==null && job.job_schedules[i].risk_assessment!=null){
                if (job?.job_done) {
                    this.permitWorkMode = true;
                } else {
                    this.permitWorkMode = false;
                }

                if (parseInt(this.user_type) !== parseInt(this.$superAdminId) && parseInt(this.user_type) !== parseInt(job.rank_fixed) && job?.job_done == null) {
                    this.$snotify.warning('Job done report is not submitted');
                    return
                }

                let job_name = job?.name + '(' + job?.code + ')';
                this.listMode = false;
                this.IRR = false;
                this.P2W = false;
                this.JobDoneStatus = true;
                this.selectedJob = job;
                this.scheduleId = job.id;
                this.componentName = job.components ? job.components : 'N/A';
                this.job_name = job_name;
            },
            addNodeFunction: function (info) {
                this.jobList = [];
                switch (info.level) {
                    case 1:
                        this.filter.jobType = 'department_id';
                        this.filter.jobId = info.id;
                        this.getAllJobList();
                        this.tableEnableMode = true;
                        break
                    case 2:
                        this.filter.jobType = 'main_component_id';
                        this.filter.jobId = info.id;
                        this.getAllJobList();
                        this.tableEnableMode = true;
                        break
                    case 3:
                        this.filter.jobType = 'component_id';
                        this.filter.jobId = info.id;
                        this.getAllJobList();
                        this.tableEnableMode = true;
                        break
                    case 4:
                        this.filter.jobType = 'sub_component_id';
                        this.filter.jobId = info.id;
                        this.getAllJobList();
                        this.tableEnableMode = true;
                        break
                    case 5:
                        this.filter.jobType = 'sub_sub_component_id';
                        this.filter.jobId = info.id;
                        this.getAllJobList();
                        this.tableEnableMode = true;
                        break
                }
            },
            //this method create for assign ranked its can be access only chief engineer means role ==3
            assignRanked(event, jobId) {
                let rankedId = event.target.value;
                this.$http.get('/api/job/' + jobId + '/' + rankedId).then(response => {
                    this.getAllJobList();
                    this.$snotify.success('Ranked Assigned Successfully');
                    setTimeout(() => $('#datatables').DataTable(), 1000)
                }).catch(e => {
                    this.$snotify.error('Ranked Can Not be Assign')
                })
            },
            //this function use for change list mode
            changeListMode() {
                this.IRR = false;
                this.P2W = false;
                this.JobDoneStatus = false;
                this.DeferReschedule = false;
                this.listMode = true;
                this.getAllJobList()
            },
            dataTableEnable() {
                // setTimeout(() => $('#datatables').DataTable(), 1000)
            },
        }
    }
</script>

<style scoped>
    .mx-datepicker {
        width: 100% !important;
    }

    @media print {
        /* Hide the button when printing */
        button {
            display: none;
        }
    }
</style>
